import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserHelperService } from '@helpers/user-helper.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    @Inject(UserHelperService)
    private userHelperService: UserHelperService
  ) {}

  public canActivate(): boolean {
    const token = this.userHelperService.getIdToken();
    if (!token) {
      void this.router.navigate(['/']);
    }
    return true;
  }
}
